import { createIcon } from '@chakra-ui/react';

export const ResetPasswordIcon = createIcon({
  displayName: 'ResetPasswordIcon',
  viewBox: '0 0 20 20',
  path: (
    <path
      d="M2.04167 15V13.3542H17.9583V15H2.04167ZM2.9375 10.0833L1.625 9.33333L2.22917 8.3125H1.04167V6.8125H2.22917L1.625 5.79167L2.9375 5.04167L3.52083 6.0625L4.10417 5.04167L5.39583 5.79167L4.8125 6.8125H6V8.3125H4.8125L5.39583 9.33333L4.10417 10.0833L3.52083 9.0625L2.9375 10.0833ZM9.39583 10.0833L8.10417 9.33333L8.70833 8.3125H7.52083V6.8125H8.70833L8.10417 5.79167L9.39583 5.04167L10 6.0625L10.5833 5.04167L11.875 5.79167L11.2917 6.8125H12.4792V8.3125H11.2917L11.875 9.33333L10.5833 10.0833L10 9.0625L9.39583 10.0833ZM15.875 10.0833L14.5833 9.33333L15.1875 8.3125H14V6.8125H15.1875L14.5833 5.79167L15.875 5.04167L16.4792 6.0625L17.0625 5.04167L18.3542 5.79167L17.75 6.8125H18.9583V8.3125H17.75L18.3542 9.33333L17.0625 10.0833L16.4792 9.0625L15.875 10.0833Z"
      fill="currentColor"
    />
  ),
  defaultProps: {
    width: '20px',
    height: '20px',
  },
});
